# The sign-up checkout and a redirect-based payment method (card
# 6a9cb1d0ea6ab4f8aea9c463).
#
# Account.plans mints the SetupIntent with no payment_method_types, so the
# Payment Element renders whatever the Stripe Dashboard has enabled — and on a
# live account that can include methods that leave the page (Cash App Pay,
# Amazon Pay, PayPal, Klarna, the bank redirects behind the non-USD prices).
# Stripe sends the browser to return_url after the customer has AUTHORIZED the
# method — the SetupIntent is confirmed — and NOT after we have subscribed. At
# that moment there is no Stripe customer, no subscription and no trial. The
# form used to pass no return_url at all (an IntegrationError at 'Complete
# Application' for any redirect method) and had nowhere to come back to: a
# bare return to #/application restarts the form and mints a fresh SetupIntent.
#
# So: a dedicated landing state (owner direction 2026-09-05) that reads the
# confirmed SetupIntent off the query, calls Account.subscribe with it, and
# only then routes to onboarding. The plan the parent chose has to survive the
# round trip too — Stripe carries the intent, not our form state — so the
# chosen price id is parked in localStorage before confirmSetup and read back
# on landing. Only the id crosses; the server resolves it against the price
# list (card 6a9cb1d0ea6ab4f8aea9c461).
#
# CommonJS on purpose, like ManageAccount/setupIntentLifecycle.coffee: webpack
# imports it either way, and the suite can require it and drive it against a
# fake window.

# The hash-router state that finishes an enrollment (app-route.coffee).
ENROLL_COMPLETE_STATE = 'enroll_complete'
ENROLL_COMPLETE_PATH = '/enroll/complete'

# What confirmSetup is told to come back to. The shell's own path plus the
# hash route; Stripe appends its parameters as a QUERY, which lands before the
# hash and is what redirectedSetupSecret reads (location.search).
enrollReturnUrl = ->
  "#{window.location.origin}#{window.location.pathname}##{ENROLL_COMPLETE_PATH}"

CHOSEN_PRICE_KEY = 'elfeet.enroll.priceId'

# localStorage can throw (private mode, blocked site data). A remembered price
# is a convenience for the return trip; the landing falls back to the same
# derivation the form uses when nothing was stored.
rememberChosenPrice = (priceId) ->
  return unless priceId?
  try window.localStorage.setItem CHOSEN_PRICE_KEY, "#{priceId}" catch e then null

chosenPrice = ->
  try (window.localStorage.getItem(CHOSEN_PRICE_KEY) or null) catch e then null

forgetChosenPrice = ->
  try window.localStorage.removeItem CHOSEN_PRICE_KEY catch e then null

module.exports = {
  ENROLL_COMPLETE_STATE
  ENROLL_COMPLETE_PATH
  enrollReturnUrl
  rememberChosenPrice
  chosenPrice
  forgetChosenPrice
}
